import find from 'lodash/find'
import dayjs from 'dayjs'
import { convertMetersToUnit } from 'supporticon/utils/units'
import { deserializePage, fetchPage } from 'supporticon/api/pages'
import { stripTags } from 'supporticon/utils/html'
import { selectAPIParams, selectLocalisation } from '../site'

// Constants
const c = {
  CLEAR: 'app/fundraisingPages/CLEAR',
  FETCH: 'app/fundraisingPages/FETCH',
  FETCH_SUCCESS: 'app/fundraisingPages/FETCH_SUCCESS',
  FETCH_FAILURE: 'app/fundraisingPages/FETCH_FAILURE',
  PERSIST: 'app/fundraisingPages/PERSIST'
}

// Selectors
export * from './selectors'

// Action
export const fetchFundraisingPage = slug => (dispatch, getState) => {
  const state = getState()
  const { apiParams } = selectAPIParams(state)
  const { uom } = selectLocalisation(state)

  return Promise.resolve()
    .then(() => dispatch({ type: c.FETCH }))
    .then(() => fetchJGPage(slug, apiParams))
    .then(data => expandedDeserializePage(data, uom))
    .then(data => dispatch({ type: c.FETCH_SUCCESS, payload: data }))
    .catch(error => {
      dispatch({ type: c.FETCH_FAILURE })
      return Promise.reject(error)
    })
}

export const refetchFundraisingPage = slug => (dispatch, getState) => {
  const state = getState()
  const { apiParams } = selectAPIParams(state)
  const { uom } = selectLocalisation(state)

  return new Promise(resolve => setTimeout(resolve, 500))
    .then(() => fetchJGPage(slug, apiParams))
    .then(data => expandedDeserializePage(data, uom))
    .then(data => dispatch({ type: c.FETCH_SUCCESS, payload: data }))
}

export const persistPageData = data => ({
  type: c.PERSIST,
  payload: data
})

export const clearPage = () => ({
  type: c.CLEAR
})

const fetchJGPage = (slug, params = {}) =>
  fetchPage(slug, true, {
    includeFitness: true,
    includeTags: true,
    fitnessParams: {
      startDate: params.startDateTime,
      endDate: params.endDateTime
    }
  })
    .then(data => ({ ...params, ...data }))

const hasUpdatedStory = (defaultStory, story) =>
  !!defaultStory && stripTags(story) !== stripTags(defaultStory)

// Reducer
const expandedDeserializePage = (page, uom) => {
  const deserializedPage = deserializePage(page)
  const goalTag = find(deserializedPage.tags, tag => tag.tagDefinition.id === 'DSFitnessGoalTargetMeters')
  const fitnessGoal = goalTag
    ? convertMetersToUnit(goalTag.value, uom)
    : parseFloat(page.pageSummaryWhat)

  return {
    ...deserializedPage,
    hasUpdatedStory: hasUpdatedStory(page.defaultPageStory, deserializedPage.story),
    hasSetFitnessGoal: !isNaN(fitnessGoal) && fitnessGoal > 0,
    url: `/fundraising/${deserializedPage.slug}`,
    adminUrl: deserializedPage.url.replace('/fundraising/', '/fundraising-edit/'),
    formattedCampaignDate: deserializedPage.campaignDate &&
      dayjs(deserializedPage.campaignDate).format('MMMM Do YYYY'),
    fitnessGoal
  }
}

export default (state = {}, { type, payload }) => {
  switch (type) {
    case c.CLEAR:
      return {}
    case c.FETCH:
      return { status: 'fetching' }
    case c.FETCH_FAILURE:
      return { status: 'failed' }
    case c.PERSIST:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload
        }
      }
    case c.FETCH_SUCCESS:
      return {
        data: payload,
        status: 'fetched'
      }
    default:
      return state
  }
}
